export default __webpack_public_path__ + "static/media/robot_forfait.88032720.png";